import * as API from './apiBase';

let baseList = {
    GetSupplierQuota: 'api/InvoiceNew/GetSupplierQuota',
    SaveSupplier: 'api/InvoiceNew/SaveSupplier'
}

/*获取供应商列表 */
export const GetSupplierQuota = () => {
    return API.POST(baseList.GetSupplierQuota, {})
};

/*编辑、保存供应商 */
export const SaveSupplier = (Id, SupplierName, IsDeleted, IsStop, Quota, language) => {
    return API.POST(baseList.SaveSupplier, {
        Id,
        SupplierName,
        IsDeleted,
        IsStop,
        Quota,
        language
    })
};
